// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7ff37a7e","389":"2d1eb9ec","453":"6bd4553c","455":"b3f90f2b","977":"002546ef"}[chunkId] + ".chunk.js";
};